export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const LOJACK_LOGO = "/lojack_logo_white.png";
export const TRACKER_LOGO = "/tracker_logo_white.png";
